function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import utils from '@/js/utils';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
export var crudUserProfileTables = {
  data: function data() {
    return {
      isBusy: false,
      busy: false,
      busy2: false,
      isBusyDetail: false,
      processing: false,
      mode: '',
      record: Object,
      record_original: Object,
      profileFiltered: [],
      overlay_message: '',
      recordSelected: null,
      items: [],
      dismissCountDown: 0,
      dismissSecs: 5,
      dangerMessage: '',
      perPage: 10,
      currentPage: 1
    };
  },
  computed: {
    readonly: function readonly() {
      return this.mode === 'view';
    },
    showMonitoringInput: function showMonitoringInput() {
      return this.mode !== 'create';
    },
    modalTitle: function modalTitle() {
      var mode = this.mode.charAt(0).toUpperCase() + this.mode.slice(1);
      var modalName = this.modalName;
      var aux = "crud." + mode;
      var modename = this.traductor(aux);
      return "".concat(modename, " ").concat(modalName);
    },
    areaName: function areaName() {
      return function (record_id) {
        /* const record = this.select_profile_areas.filter(rec => rec.record_id === record_id)
        let recordName = ''
        if (record.length) {
          recordName = record[0].area_description
        }
        return recordName
        */
        return '';
      };
    },
    userProfileName: function userProfileName() {
      return function (record_id) {
        /* const record = this.select_profile_users.filter(rec => rec.record_id === record_id)
        let recordName = ''
        if (record.length) {
          recordName = record[0].userprofile_description
        }*/
        return '';
      };
    },
    areasActive: function areasActive() {
      return this.select_areas.filter(function (rec) {
        return rec.flag_active;
      });
    },
    profileUserActive: function profileUserActive() {
      // return this.select_profile_users.filter(rec => rec.flag_active)
    }
  },
  watch: {
    /* 'record.area_id': function() {
      const area_id = this.record.area_id
      if (this.select_profile_users) {
        this.profileFiltered = this.select_profile_users.filter(rec => rec.area_id === area_id)
      }
    }*/
  },
  created: function created() {
    this.getRecords();
  },
  methods: {
    changeArea: function changeArea() {
      var _this = this;
      this.parametros = {
        pagination: {
          'limit': 10000,
          'offset': 0
        },
        domain: 'intercorp.com.pe',
        area_id: this.record.area_id
      };
      UserProfileService.getUserProfileByArea(this.parametros).then(function (data) {
        console.log(data);
        // this.profileFiltered = data.data;
        data.data.forEach(function (element) {
          _this.profileFiltered.push({
            value: element.userprofile_id,
            text: element.userprofile_description
          });
        });
      }, function (err) {
        console.og(err);
      });
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getRecords: function getRecords() {},
    getValuesToUpdate: function getValuesToUpdate(record, record_original) {
      var toSave = Object.keys(record).reduce(function (diff, key) {
        if (record[key] === record_original[key]) return diff;
        return _objectSpread(_objectSpread({}, diff), {}, _defineProperty({}, key, record[key]));
      }, {});
      var keys = Object.keys(toSave);
      var oldValues = {};
      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        if (key === 'load_date') continue;
        oldValues[key] = record_original[key];
      }
      toSave.record_id = record_original.record_id;
      return {
        toSave: toSave,
        oldValues: oldValues
      };
    },
    showModal: function () {
      var _showModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data, mode) {
        var _this2 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.mode = mode;
              this.clearFieldsDetail();
              this.pagination2.current = 1;
              if (!data) {
                _context.n = 2;
                break;
              }
              this.recordSelected = data.index;
              this.record = utils.cloneJSON(data.item);
              this.record_clone = utils.cloneJSON(data.item);
              _context.n = 1;
              return this.loadTables();
            case 1:
              _context.n = 3;
              break;
            case 2:
              this.record_details = [{}];
              this.record = {};
            case 3:
              if (this.mode !== 'create') {
                this.changeArea();
              }
              this.getProjects();
              this.$nextTick(function () {
                return _this2.$refs.dialog.onOpen();
              });
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function showModal(_x, _x2) {
        return _showModal.apply(this, arguments);
      }
      return showModal;
    }(),
    loadTables: function loadTables() {
      var _this3 = this;
      this.record_details = [];
      this.record_details_delete = [];
      var area_id = this.record.area_id;
      var userprofile_id = this.record.userprofile_id;
      this.isBusyDetail = !this.isBusyDetail;
      var parametros = {
        'domain': 'intercorp.com.pe',
        'pagination': {
          limit: 1000,
          offset: 0
        },
        area_id: area_id,
        userprofile_id: userprofile_id
      };
      UserProfileService.getTables(parametros).then(function (data) {
        _this3.firstChange = utils.cloneJSON(data.data);
        _this3.record_details = data.data;
        _this3.record_details.forEach(function (item) {
          if (!item.hasOwnProperty("source")) {
            item.source = "bigquery";
          }
        });
        _this3.isBusyDetail = !_this3.isBusyDetail;
      }, function (err) {
        _this3.isBusyDetail = !_this3.isBusyDetail;
      });
    },
    changeUserprofile: function changeUserprofile() {
      this.loadTables();
    },
    toggleBusy: function toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    resetModal: function resetModal() {
      this.$bvModal.hide(this.modalId);
    },
    onDelete: function onDelete(record) {
      this.record = record;
      this.processing = false;
      this.busy = true;
    },
    onCancelDelete: function onCancelDelete() {
      this.busy = false;
    },
    onConfirmDelete: function onConfirmDelete() {
      var _this4 = this;
      this.processing = true;
      this.overlay_message = 'Deleting';
      console.log(this.record);
      var data = {
        domain: 'intercorp.com.pe',
        'area_id': this.record.area_id,
        'userprofile_id': this.record.userprofile_id
      };
      UserProfileService.deleteUserProfileById(data).then(function (datos) {
        console.log(datos);
        _this4.busy = _this4.processing = false;
        _this4.getRecords();
      }, function (err) {
        _this4.busy = _this4.processing = false;
      });
    },
    rowClassFlag: function rowClassFlag(item) {
      return item && item.flag_active ? 'flag_active' : 'flag_deactive';
    },
    show_alert_and_fade: function show_alert_and_fade() {
      var _this5 = this;
      this.alert = !this.alert;
      this.resetTimer();
      var myTimer = window.setTimeout(function () {
        _this5.alert = false;
      }, 4000);
    },
    dismissible_close: function dismissible_close(value) {
      this.alert = value;
      this.resetTimer();
    },
    resetTimer: function resetTimer() {
      this.countDown.timer = 4;
    },
    queryAndIndeterminate: function queryAndIndeterminate() {
      var _this6 = this;
      this.dismissCountDown = 0;
      var interval = setInterval(function () {
        if (_this6.dismissCountDown === 100) {
          clearInterval(interval);
          _this6.dismissCountDown = 0;
        } else {
          _this6.dismissCountDown += 2.5;
        }
      }, 100);
    }
  }
};